<ng-container *ngTemplateOutlet="type === 'single' ? multiDatePicker : dateRangePicker"></ng-container>

<ng-template #multiDatePicker>
	<div style="position: relative" #datePickerContainer>
		<div style="display: hidden" [matMenuTriggerFor]="appMenu" #topHiddenTrigger>
		</div>
		<mat-form-field appearance="outline" class="w-100-p" [ngClass]="{ 'no-wrapper-padding': isError }">
			<mat-label *ngIf="!hideLabel">{{ 'SELECT_DATES' | translate }}</mat-label>
			<input type="text" [value]="selectedDateViewString" readonly matInput [placeholder]="placeholderText" data-testid="date-input"/>
			<button
                data-testid="date-range-button"
				class="trigger-btn"
				[disabled]="disabled"
				matSuffix
				mat-icon-button
				(click)="onDatePickerTriggerBtnClick($event, topHiddenTrigger, bottomHiddenTrigger)"
			>
				<mat-icon [ngClass]="isDatePickerOpen ? 'yellow-icon' : 'grey-icon'">date_range</mat-icon>
			</button>
		</mat-form-field>
		<div style="display: hidden; position: absolute; bottom: 20px" [matMenuTriggerFor]="appMenu" #bottomHiddenTrigger>
	
		</div>
	</div>
	<mat-menu [yPosition]="datepickerYPosition" xPosition="after" #appMenu="matMenu" class="drop-calendar" (closed)="onClose()">
		<div (click)="$event.stopPropagation()" (keydown)="handleKeyDown($event)">
			<mat-calendar
				(selectedChange)="select($event, calendar)"
				[dateClass]="isSelected"
				[dateFilter]="dateFilterFn"
				(viewChanged)="viewChangeHandler($event)"
				#calendar
			></mat-calendar>
		</div>
	</mat-menu>
</ng-template>

<ng-template #dateRangePicker>
  <mat-form-field appearance="outline" class="w-100-p" [ngClass]="{'no-wrapper-padding ': isError}">
    <mat-label *ngIf="!hideLabel">{{ 'SELECT_DATE_RANGE' | translate }}</mat-label>
    <input matInput (dateChange)="onDateRangeChange($event)" [placeholder]="placeholderText" [min]="minDate" [max]="maxDate"
        [satDatepicker]="picker2" [(ngModel)]="dateRange" [disabled]="disabled"  data-testid="date-range-input"/>

    <sat-datepicker-toggle data-testid="date-range-toggle"  matSuffix [for]="picker2"></sat-datepicker-toggle>
    <sat-datepicker  id="du-12" #picker2 [rangeMode]="true"></sat-datepicker>
  </mat-form-field>
</ng-template>
